import { ActivatedRouteSnapshot, ResolveFn, Route, RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { KidsPotentielleStore } from './kids-potentielle.store';
import { KIDS_PATH, KIDS_TITLE } from '../../mgs-path-defs';
import { kidsDatenResolver } from '../kids-daten.resolver';
import { mgsIconsResolver } from '../../mgs-svg-icon.helper';
import { mgsAuthenticatedGuard, mgsKidsGuard } from '../../mgs-guards';

const kidsPotentielleResolver: ResolveFn<void> = async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const kidsPotentielleStore = inject(KidsPotentielleStore);
  if (!kidsPotentielleStore.loaded()) {
    await kidsPotentielleStore.load();
  }
};

export const kidsPotentielleRoute: Route = {
  path: KIDS_PATH,
  title: KIDS_TITLE,
  loadComponent: () => import('./kids-potentielle.component'),
  canActivate: [mgsAuthenticatedGuard, mgsKidsGuard],
  resolve: { kidsPotentielle: kidsPotentielleResolver, kidsDaten: kidsDatenResolver, icons: mgsIconsResolver }
};
